import React from "react";
import { useStyles } from "./Styles";
const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <span style={{ color: "rgba(255,255,255,0.7)", marginRight: "5px" }}>© 2026 </span>
      <span style={{ color: "#ffffff", marginRight: "5px", fontWeight: 600 }}> Exits, </span>
      <span style={{ color: "rgba(255,255,255,0.7)", marginRight: "5px" }}> All Rights Reserved </span>
      <span style={{ color: "rgba(255,255,255,0.4)", marginRight: "5px" }}>·</span>
      <span style={{ color: "rgba(255,255,255,0.7)" }}>
        Designed &amp; Developed by{" "}
        <a
          href="https://www.anspire.agency"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#ffffff", textDecoration: "none", fontWeight: 500 }}
        >
          Anspire Agency
        </a>
      </span>
    </footer>
  );
};
export default Footer;
